export default "__VITE_ASSET__BcHSGT09__"